module.exports = __webpack_public_path__ + "7d5ec2951a3233ef3e2addb821186f5d.svg";